const state = {
  categories: null,
}

const mutations = {
  RESET_CATEGORIES: function (state) {
    state.categories = null;
  },
  ADD_CATEGORY: function (state, category) {
    if (state.categories !== null) {
      if (state.categories.findIndex(cat => {
        return cat.id === category.id
      }) === -1) {
        state.categories.push(category);
      }
    }
    else{
      state.categories = [];
      state.categories.push(category);
    }


  }
}

const actions = {

  initializeCategories({ commit, rootState, state, getters }, devices) {

    return new Promise(resolve => {
      /* console.log(devices) */
      let promiseArray = devices.map(device => {
        return Promise.all(device.categories.map(cat => {
          return rootState.Database.db
            .collection("categories")
            .doc(cat)
            .get()
            .then(function (doc) {
              if (doc.exists) {
                let data = doc.data();
                data['id'] = doc.id;
                /* console.log(data); */
                commit('ADD_CATEGORY', data);
              }
            });
        }));

      })

      Promise.all(promiseArray).then(() => {
        resolve(true);
      })

    })
  },
}

const getters = {
  getCategories(state) {
    if (state.categories !== null) {
      return state.categories
    }
    else {
      return []
    }

  }
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Categories.js